export default __webpack_public_path__ + "2018 pH-Controlled Assembly of 3D and 2D Zinc-Based Metal-Organic Frameworks with Tetrazole Ligands.pdf";